import { render, staticRenderFns } from "./FormPaymentOrder.vue?vue&type=template&id=1cb477c9&"
import script from "./FormPaymentOrder.vue?vue&type=script&lang=js&"
export * from "./FormPaymentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports